import { CreateAuthentication } from "@musicaudienceexchange/firebase-auth-ui";

export const { UserContext, UserProvider, useUser } = CreateAuthentication();
